// Generated by purs version 0.15.15
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
var imap = function (dict) {
    return dict.imap;
};
var ivoid = function (dictIxFunctor) {
    return imap(dictIxFunctor)(Data_Function["const"](Data_Unit.unit));
};
var ivoidLeft = function (dictIxFunctor) {
    var imap1 = imap(dictIxFunctor);
    return function (f) {
        return function (x) {
            return imap1(Data_Function["const"](x))(f);
        };
    };
};
var ivoidRight = function (dictIxFunctor) {
    var imap1 = imap(dictIxFunctor);
    return function (x) {
        return imap1(Data_Function["const"](x));
    };
};
export {
    imap,
    ivoid,
    ivoidRight,
    ivoidLeft
};
//# sourceMappingURL=index.js.map
